const config = {
    API_URL: process.env.REACT_APP_API_ENDPOINT,
    HOME_URL: window.location.origin + "/dashboard",
    ENC_KEY: process.env.REACT_APP_ENC_KEY,
    OIDC_URL: process.env.REACT_APP_OIDC_AUTHORITY_ENDPOINT || "",
    INACTIVITY_TIMEOUT_MINUTES: 15
};

export default config;
